const $header = $('.SearchForm--Header');
const $headerTrigger = $('.SearchSubmit--Header');
const $headerInput = $header.find('input[type=text]');
$headerTrigger.on('click', function () {
  $('.MainNavigation__Item--Language').removeClass('active');
  $('.MainNavigation__Item--Quick').removeClass('active');
  $header.addClass('active');
  $headerInput.focus();
});

$header.on('focusout', function () {
  if (!$.contains($header, document.activeElement)) {
    $header.removeClass('active');
  }
  $('.MainNavigation__Item--Language').removeClass('active');
  $('.MainNavigation__Item--Quick').removeClass('active');
});

$(document).on('click', function (e) {
  if (
    !$('.MainNavigation__Item--Language').is(e.target) &&
    !$('.MainNavigation__Item--Language').has(e.target).length
  ) {
    $('.MainNavigation__Item--Language').removeClass('active');
  }
  if (
    !$('.MainNavigation__Item--Quick').is(e.target) &&
    !$('.MainNavigation__Item--Quick').has(e.target).length
  ) {
    $('.MainNavigation__Item--Quick').removeClass('active');
  }
});

$(document).on('scroll', function (e) {
  $('.MainNavigation__Item--Language').removeClass('active');
  $('.MainNavigation__Item--Quick').removeClass('active');
});
